import { render, staticRenderFns } from "./EditButton.vue?vue&type=template&id=2901da53&"
import script from "./EditButton.vue?vue&type=script&lang=ts&"
export * from "./EditButton.vue?vue&type=script&lang=ts&"
import style0 from "./EditButton.vue?vue&type=style&index=0&id=2901da53&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports